import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

import { select } from '@angular-redux/store';
import { TranslateService } from '@ngx-translate/core';

import {
    ApplicationFacade,
    CustomerFacade,
    CustomerService,
    LoginFacade,
    NotificationFacade,
    SessionService
} from '@ridango/components';
import { AppStartupService, Language, LogService, NetworkService, OnboardingService } from '@ridango/core';
import { HeaderMenuService } from '../../../services/header-menu.service';

import { HelperService } from '../../../services/helper.service';
import { HeaderComponent } from '../header.component';
import { ThemeFeature } from '@ridango/core/lib/enums/features.enum';
import { FeatureFlagService } from '@ridango/feature-flags';
import Env from '@ridango/core/env';
import { takeUntil } from 'rxjs/operators';

import { FEATURE_FLAGS } from '@ridango/core';
import { LocaleService } from '../../../../services/locale.service';
import { AnalyticsService } from '@ridango/core/lib/services/analytics.service';

@Component({
    selector: 'gl-header-landing-template-gl',
    templateUrl: './header-landing-template-gl.component.html',
    styleUrls: ['./header-landing-template-gl.component.scss']
})
export class HeaderLandingTemplateGlComponent extends HeaderComponent implements OnInit {
    @Input() mobileMenuOpen = false;
    @Input() languages: Language[];
    @Input() selected: Language;
    @Input() loggedInCustomer: string;
    @Output() onToggleMobileMenu: EventEmitter<any> = new EventEmitter();
    @Output() onCloseMobileMenu: EventEmitter<any> = new EventEmitter();
    @Output() requestLanguageChange: EventEmitter<Language> = new EventEmitter();
    @Output() onOidcLogin: EventEmitter<void> = new EventEmitter();

    @select(['auth', 'customer', 'data']) customer$;

    headerLinks: string[] = this.env.HEADER.LINKS;
    themeFeature = ThemeFeature;
    showBookARide = true;

    constructor(
        appConfig: AppStartupService,
        applicationFacade: ApplicationFacade,
        eRef: ElementRef,
        ls: LogService,
        @Inject(DOCUMENT) document: any,
        router: Router,
        ridangoAuth: SessionService,
        notification: NotificationFacade,
        renderer: Renderer2,
        helper: HelperService,
        loginFacade: LoginFacade,
        localeService: LocaleService,
        translate: TranslateService,
        @Inject('ENV') env: Env,
        private featureFlags: FeatureFlagService,
        onboardingService: OnboardingService,
        customerService: CustomerService,
        customerFacade: CustomerFacade,
        networkService: NetworkService,
        headerMenuService: HeaderMenuService,
        analyticsService: AnalyticsService
    ) {
        super(
            appConfig,
            applicationFacade,
            eRef,
            ls,
            document,
            router,
            localeService,
            ridangoAuth,
            notification,
            renderer,
            helper,
            loginFacade,
            translate,
            env,
            onboardingService,
            customerService,
            customerFacade,
            networkService,
            headerMenuService,
            analyticsService
        );
    }

    ngOnInit() {
        super.ngOnInit();

        this.featureFlags
            .getFlags(FEATURE_FLAGS.BookARide)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((flagValue) => {
                this.showBookARide = flagValue;
            });
    }

    toggleMobileMenu() {
        this.onToggleMobileMenu.emit();
    }

    closeMobileMenu() {
        this.onCloseMobileMenu.emit();
    }

    changeLanguage(lang) {
        this.requestLanguageChange.emit(lang);
    }
}
